/** What happened to one line, field, triple or step between two versions. */
export type ChangeKind = "added" | "removed" | "changed" | "unchanged";

const KIND_CLASS: Readonly<Record<ChangeKind, string>> = {
  added: "app-change-added",
  removed: "app-change-removed",
  changed: "app-change-changed",
  unchanged: "app-change-unchanged",
};

/** The sign shown before a change; the kind is also said in words for screen readers. */
export const CHANGE_SIGN: Readonly<Record<ChangeKind, string>> = { added: "+", removed: "−", changed: "~", unchanged: " " };

/** The colour of a change, for a cell or span that marks one without being a ChangeRow. */
export function changeToneClass(kind: ChangeKind): string {
  return KIND_CLASS[kind];
}
